'use strict';

const filterParentModel = require('od-modules/models/accommodation_filter');

module.exports = Odigeo.Model.extend(filterParentModel).extend({
    filterMetadataPath: 'accommodationFiltersMetadata.accommodationOurSelectionMetadata',
    filterStatusPath: 'accommodationSearchResultsMetadata.filterByOurSelectionModel',
});
